import React from 'react';

import { IconWrapperProps } from './IconWrapperProps';

const IconWrapper: React.FC<IconWrapperProps> = (props) => {
  const { size = 25, children, viewBox = '0 0 138.3 142.8', className, ...restProps } = props;
  return (
    <svg
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      xmlSpace="preserve"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={size}
      height={size * 1.2}
      {...restProps}
    >
      {children}
    </svg>
  );
};

export default IconWrapper;
